import { render } from "./TheExhibitors.vue?vue&type=template&id=95317030&scoped=true"
import script from "./TheExhibitors.vue?vue&type=script&lang=ts"
export * from "./TheExhibitors.vue?vue&type=script&lang=ts"

import "./TheExhibitors.vue?vue&type=style&index=0&id=95317030&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-95317030"

export default script